import { LogoLoader as UiLogoLoader } from '@membranehq/console/components/Loader'
import { twMerge } from 'tailwind-merge'

import { Popup as ConsolePopup } from './Popup'

function LogoLoader({ className = '', ...props }) {
  return <UiLogoLoader className={twMerge('util-loader--logo', className)} {...props} />
}

export function EmptyPageLoader() {
  return (
    <div className={'noJsAppBackdrop'}>
      <LogoLoader />
    </div>
  )
}

export function PaneLogoLoader() {
  return (
    <ConsolePopup.Content className='w-full h-full grid place-content-center'>
      <LogoLoader />
    </ConsolePopup.Content>
  )
}
